import React from 'react'

import { Link } from 'gatsby'

import styles from './Navbar.module.css'

import { Grid } from '@material-ui/core'

import logo from '../../images/ww-logo.jpg'

const Navbar = () => {
  return (
    <Grid container alignItems="center" justify="center" className={styles.nav}>
      <Grid item xs={12} md={10} lg={8} className={styles.headerNav}>
        <img src={logo} alt="wood wizards logo" />
        <div className={styles.links}>
          <Link exact to="/" activeClassName={styles.active}>
            Home
          </Link>
          <Link exact to="/about" activeClassName={styles.active}>
            About
          </Link>
          <Link exact to="/products" activeClassName={styles.active}>
            Products
          </Link>
          <Link exact to="/contact" activeClassName={styles.active}>
            Contact
          </Link>
        </div>
      </Grid>
    </Grid>
  )
}

export default Navbar
